"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _ReadyRound = _interopRequireDefault(require("@rsuite/icon-font/lib/status/ReadyRound"));

// Generated by script, don't edit it please.
var ReadyRound = (0, _createSvgIcon["default"])({
  as: _ReadyRound["default"],
  ariaLabel: 'ready round',
  category: 'status',
  displayName: 'ReadyRound'
});
var _default = ReadyRound;
exports["default"] = _default;
module.exports = exports.default;